import { PostCommentedInterface } from './post-commented.interface';

export enum EntityType {
  COMMUNITY = 'community',
  PROJECT = 'project',
}

export interface LeadPostCommentedInterface extends PostCommentedInterface {
  parent_entity_type: EntityType;
}
